import { forceLogout, isForceLoggingOut } from './forceLogout'
import { userManager } from './oidcClient'

class TokenRefreshManager {
  private refreshPromise: Promise<string | null> | null = null

  /**
   * 實際執行 Token 刷新
   * 使用 OIDC client 的 signinSilent 作為唯一 refresh 路徑
   * tokenService 由 userLoaded event 的 tokenUpdateHandler 自動同步
   */
  private async doRefresh(): Promise<string | null> {
    if (isForceLoggingOut()) {
      return null
    }

    const storedUser = await userManager.getUser()
    const hasRefreshToken = !!storedUser?.refresh_token

    if (!hasRefreshToken) {
      console.warn('No refresh_token available, forcing logout')
      await forceLogout({ saveRedirectPath: true })
      return null
    }

    try {
      const user = await userManager.signinSilent()
      return user?.access_token ?? null
    } catch (error) {
      console.error('Token refresh failed:', error)
      await forceLogout({ saveRedirectPath: true })
      throw error
    }
  }

  /**
   * 更新 Access Token
   * 如果已經在刷新中，所有呼叫者共用同一個 Promise
   * @returns {Promise<string | null>} 新的 Access Token
   * @throws {Error} 如果刷新失敗或沒有獲取到新的 Access Token
   */
  public async refreshToken(): Promise<string | null> {
    if (this.refreshPromise) {
      return this.refreshPromise
    }

    this.refreshPromise = this.doRefresh()

    try {
      return await this.refreshPromise
    } finally {
      this.refreshPromise = null
    }
  }
}

export const tokenRefreshManager = new TokenRefreshManager()
